<div class="container-style">
  <app-custom-table #customTable [showRecover]="true" [showCheckbox]="true" [isMultipleSelect]="true"
    [showButtonAdd]="false" [data]="dataMaintenanceSchedulingDetail" [headers]="header" [previousFilters]="filters"
    [clearSelectionTrigger]="clearSelectionTrigger" (onRecoverData)="getPendingMaintenanceSchedulingByOrder()"
    (selectionChange)="selectionChange($event)" (onPageChange)="onPageChange($event)"
    (onFilterChange)="onFilterChange($event)">
  </app-custom-table>
  <div class="d-flex justify-content-end mt-2">
    <app-custom-button [title]="'Generar Ordenes'" [label]="'Generar Ordenes'" [disabled]="disabledStart"
      [severity]="'success'" [variant]="undefined" [width]="'7.5rem'"
      (onClick)="generateMaintenanceOrder()"></app-custom-button>
  </div>